export default {
  //get all GROUPs
  GET_GROUPS_STUDENT_REQUEST: "GET_GROUPS_STUDENT_REQUEST",
  GET_GROUPS_STUDENT_SUCCESS: "GET_GROUPS_STUDENT_SUCCESS",
  GET_GROUPS_STUDENT_FAIL: "GET_GROUPS_STUDENT_FAIL",

  GROUPS_LOADING: "GROUPS_LOADING",
};
